import React, { useCallback, useEffect, useState } from 'react'
import BottomSheet from '../../helpers/overlays/bottom-sheet/bottom-sheet'
import styles from './styles.module.scss'
import SvgCopy from '@/src/assets/svgs/collection/copy.svg'
import SvgWhatsApp from '@/src/assets/svgs/social/whatsapp-o.svg'
import SvgFacebook from '@/src/assets/svgs/social/facebook-o.svg'
import { useMiscFunctions } from '@/src/hooks/useMiscFunctions'

const checkIsMobile = () => {
    if (typeof window === 'undefined') return false

    const userAgent = window.navigator.userAgent || window.navigator.vendor
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i

    return mobileRegex.test(userAgent.toLowerCase())
}

interface Props {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    url: string
    title: string
    text?: string
    isCoupon?: boolean
    copyText?: string
}

interface RowButtonProps {
    title: string
    color?: string
    svg: React.ReactElement
    onClick: () => void
}

export default function ShareButtons(props: Props) {
    const { copyToClipboard } = useMiscFunctions()

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        setIsMobile(checkIsMobile())
    }, [])

    const handleShare = useCallback(async () => {
        if (isMobile && navigator.share) {
            try {
                await navigator.share({
                    title: props.title,
                    text: `${props.isCoupon ? '📢 ' : ''}${props.title}\n\n📝 ${props.text ? `${props.text}\n\n` : ''}🔗 ${props.isCoupon ? 'Aplicar cupom' : 'Confira mais em'}:`,
                    url: props.url
                })
            }
            catch (e) {
                console.apm(e)
            }
            finally {
                props.setIsOpen(false)
            }
        }
    }, [props, isMobile])

    if (!isMobile) {
        const rowButtons = (): RowButtonProps[] => [
            {
                title: 'Copiar',
                svg: <SvgCopy className={styles.svgCopy} />,
                onClick: () => copyToClipboard(props.url, props.copyText)
            },
            {
                title: 'WhatsApp',
                color: '#6ac861',
                svg: <SvgWhatsApp />,
                onClick: () => {
                    let m: string[] = [];
                    m.push(`${props.isCoupon ? '📢 ' : ''}*${props.title}*`)

                    if (props.text)
                        m.push("\n\n📝 " + props.text)

                    m.push(`\n\n🔗 ${props.isCoupon ? 'Aplicar cupom' : 'Confira mais em'}:`)
                    m.push("\n" + props.url)

                    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(m.join(""))}`, '_blank')
                }
            },
            {
                title: 'Facebook',
                color: '#197cfc',
                svg: <SvgFacebook />,
                onClick: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(props.url)}&quote=${encodeURIComponent(props.text ?? '')}`, '_blank')
            }
        ]

        return (
            <BottomSheet isOpen={props.isOpen} onClose={() => props.setIsOpen(false)}>
                <div className={styles.container}>
                    <h5 className='font-xmd'>Compartilhar</h5>
                    <div className={styles.row}>
                        {
                            rowButtons().map((item, index) => (
                                <div key={index} className={styles.btnContainer} onClick={item.onClick}>
                                    <div style={item.color ? { backgroundColor: item.color } : {}} className={styles.svgArea}>
                                        {item.svg}
                                    </div>
                                    <span>{item.title}</span>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </BottomSheet>
        )
    }

    handleShare()
    return null
}